import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import styled from 'styled-components'
import ModalView from '@/components/modal-view'
import AwardBg from './imgs/award-modal-bg@2x.png';
import RedBg from './imgs/red-bg@2x.png';
import RedBtn from './imgs/red-btn@2x.png';

const AwardModal = ({ onClose }, ref) => {
  const [show, setShow] = useState(false);
  const [showText, setShowText] = useState('');
  const intervalRef = useRef(null)
  const countRef = useRef();
  const [isRedAward, setIsRedAward] = useState(false);
  const modalRef = useRef();

  const handleStart = () => {
    countRef.current.innerText = 3;
    intervalRef.current = setInterval(() => {
      const curCount = Number(countRef.current.innerText);
      
      if (!intervalRef.current) {
        return;
      }
      if (curCount === 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setShow(false);
        return;
      }
      countRef.current.innerText = curCount - 1
    }, 1000)
  }

  useImperativeHandle(ref, () => {
    return {
      show: (text, isRed) => {
        setIsRedAward(isRed);
        setShowText(text);
        setShow(true);
        if (!isRed) {
          setTimeout(() => {
            handleStart();
          }, 200)
        }
      }
    }
  })

  const handleClose = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setShow(false)
    onClose && onClose();
  }

  const handleOpen = () => {
    setIsRedAward(false)
    setTimeout(() => {
      modalRef.current.refresh();
      handleStart();
    }, 200)
  }

  return (
    <ModalView
      visible={show}
      ref={modalRef}
      content={
        <Container>
          {
            !isRedAward ? (
              <div className='award-bg'>
                <div className="award-text">{showText}</div>
                <div className="award-btn" onClick={handleClose}>开心收下 (<span ref={countRef}>3</span>s)</div>
              </div>
            ) : (
              <div className="red-wrap">
                <img className="red-bg" src={RedBg} alt="" />
                <img className="red-btn" src={RedBtn} alt="" onClick={handleOpen}/>
              </div>
            )
          }
        </Container>
      }
    />
  )
}

export default React.memo(forwardRef(AwardModal));

const Container = styled.div`
  .award-bg {
    font-size: 0;
    width: 280px;
    background-image: url(${AwardBg});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 330px;
  }
  .award-text {
    font-weight: 500;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 42px;
    text-align: center;
    padding-top: 171px;
  }
  .award-btn {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    padding-top: 58px;
  }
  .red-wrap {
    position: relative;
    width: 280px;
    .red-bg {
      width: 100%;
    }
    .red-btn {
      width: 80px;
      height: 80px;
      position: absolute;
      bottom: 52px;
      left: calc(50% - 40px);
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_230/award-modal.js